/* Mridaya Native feed: card grid + full-screen social-style viewer + stories + AJAX cart. */
(function () {
  const dataEl = document.getElementById('mn-data');
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const $ = (id) => document.getElementById(id);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => {
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: D.currency || 'INR', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '₹' + Math.round(cents / 100); }
  };
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  // ---------- data ----------
  const ALL = D.products.filter((p, i, a) => a.findIndex((x) => x.handle === p.handle) === i);
  const LIST = ALL.filter((p) => !D.hideNoImage || p.imgs.length || p.handle === D.start);
  const BY = Object.fromEntries(ALL.map((p) => [p.handle, p]));
  const sellable = (p) => p.price > 0 && p.available && p.variant;
  const priceText = (p) => (p.price > 0 ? money(p.price) : 'Price soon');
  const metaText = (p) => [p.finish, (p.type || '').toLowerCase()].filter(Boolean).join(' ');
  const tall = (p) => p.tier === 'statement' || p.tier === 'signature';
  const saved = new Set(store.get('mn-saved', []));
  const seen = new Set(store.get('mn-seen', []));
  let cartCount = +($('badge').textContent || 0);

  const ICON = {
    truck: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    shield: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    cash: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="6" width="18" height="12"/><circle cx="12" cy="12" r="2.5"/></svg>',
    chat: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" width="S" height="S" fill="F" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>',
    box: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
    ret: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5L4 9l4 4"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" width="S" height="S" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15"/><path d="M5 19l7-7"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>',
    photos: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="7" y="3" width="14" height="14"/><path d="M3 7v14h14"/></svg>'
  };
  const ic = (k, s, fill) => (ICON[k] || ICON.box).replace(/width="S" height="S"/, `width="${s}" height="${s}"`).replace('fill="F"', `fill="${fill || 'none'}"`);
  const T = D.trust;
  const TRUST = (T.items || []).filter((i) => i.title).map((i) => [i.icon, i.title, i.sub || '']);
  if (T.whatsapp) TRUST.push(['chat', 'A real person on WhatsApp', 'Ask about size or placement before you buy.']);

  // ---------- intro trust + header ----------
  $('introTrust').innerHTML = TRUST.slice(0, 2).map(([k, b]) => `<span>${ic(k, 14)}${esc(b)}</span>`).join('');
  const top = document.querySelector('.top');
  window.addEventListener('scroll', () => top.classList.toggle('compact', window.scrollY > 40), { passive: true });
  $('lockup').addEventListener('click', (e) => { if (location.pathname === D.routes.root || location.pathname === '/') { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); } });
  const sized = (u, w) => u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u;

  // ---------- toast ----------
  let toastT;
  function toast(msg) { const t = $('toast'); t.textContent = msg; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 1900); }

  // ---------- grid ----------
  function card(p) {
    const img = p.thumbs[0] || p.imgs[0];
    const peek = p.thumbs[2] || p.thumbs[1];
    const n = p.imgs.length;
    return `<article class="card">
      <button class="card__media" type="button" data-open="${esc(p.handle)}" style="aspect-ratio:${tall(p) ? '2 / 3' : '4 / 5'}" aria-label="Open ${esc(p.title)} full screen">
        ${img ? `<img loading="lazy" alt="${esc(p.title)}" src="${esc(img)}">` : ''}
        ${peek ? `<img class="peek" loading="lazy" alt="" src="${esc(peek)}">` : ''}
        ${tall(p) ? `<span class="card__tier">${esc(p.tier)}</span>` : ''}
        ${p.price > 0 && !p.available ? '<span class="card__soon">Sold out</span>' : ''}
      </button>
      <div class="card__body"><div><p class="card__name">${esc(p.title)}</p><p class="card__price">${priceText(p)}${n > 1 ? ` · <span class="card__photos">${ICON.photos}${n} photos</span>` : ''}</p></div>
      <button class="add-sq" type="button" data-add="${esc(p.handle)}" aria-label="Add ${esc(p.title)} to cart" ${sellable(p) ? '' : 'disabled style="opacity:.35;cursor:not-allowed"'}>${ICON.plus}</button></div>
    </article>`;
  }
  const STYLE_CYCLE = ['clay', 'paper', 'dark'];
  let stIdx = 0;
  D.moments.forEach((m) => { if (m.type === 'statement') { m.look = m.style && m.style !== 'auto' ? m.style : STYLE_CYCLE[stIdx % 3]; stIdx++; } });
  const MARK = '<svg class="bm__mark" viewBox="0 0 40 40" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><circle cx="20" cy="20" r="15"/><path d="M5 24h30M9 29h22M14 34h12"/></svg>';
  function momentHTML(m) {
    if (m.type === 'statement') {
      return `<section class="moment bm bm--${m.look}"><div class="bm__inner pad">${m.look === 'clay' ? MARK : ''}${m.eyebrow ? `<p class="bm__eyebrow">${esc(m.eyebrow)}</p>` : ''}<p class="bm__title">${esc(m.heading)}</p>${m.text ? `<p class="bm__text">${esc(m.text)}</p>` : ''}${m.look === 'paper' ? '<span class="bm__orn" aria-hidden="true"></span>' : ''}</div></section>`;
    }
    if (m.type === 'video') {
      if (!m.video && !m.img) return '';
      const media = m.video ? `<video data-lazy="${esc(m.video)}" ${m.img ? `poster="${esc(m.img)}"` : ''} muted loop playsinline preload="none"></video>` : `<img alt="" src="${esc(m.img)}" loading="lazy">`;
      return `<section class="moment bv"><div class="bv__frame">${media}<div class="bv__shade"></div>
        ${m.video ? `<button class="bv__toggle" type="button" data-vtoggle aria-label="Pause video"><svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><rect x="7" y="5" width="3.5" height="14"/><rect x="13.5" y="5" width="3.5" height="14"/></svg></button>` : ''}
        <div class="bv__text pad">${m.eyebrow ? `<p class="bm__eyebrow">${esc(m.eyebrow)}</p>` : ''}<p class="bv__title">${esc(m.heading)}</p>${m.text ? `<p class="bv__body">${esc(m.text)}</p>` : ''}</div></div></section>`;
    }
    if (m.type === 'image') {
      if (!m.img) return '';
      return `<section class="moment bi"><div class="bi__head pad">${m.eyebrow ? `<p class="bm__eyebrow">${esc(m.eyebrow)}</p>` : ''}<p class="bi__title">${esc(m.heading)}</p></div>
        <div class="bi__frame" style="aspect-ratio:${esc(m.ratio || '3 / 2')}"><img alt="" src="${esc(m.img)}" loading="lazy" style="object-position:${m.x == null ? 50 : +m.x}% ${m.y == null ? 50 : +m.y}%"></div></section>`;
    }
    if (m.type === 'trust') {
      if (!TRUST.length) return '';
      return `<section class="moment bt"><div class="pad">${m.eyebrow ? `<p class="bm__eyebrow">${esc(m.eyebrow)}</p>` : ''}<p class="bt__title">${esc(m.heading)}</p>
        <ul class="bt__list">${TRUST.map(([k, b, s]) => `<li><span class="bt__ic">${ic(k, 20)}</span><div><b>${esc(b)}</b>${s ? `<span>${esc(s)}</span>` : ''}</div></li>`).join('')}</ul></div></section>`;
    }
    return '';
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-vtoggle]'); if (!b) return;
    const v = b.parentElement.querySelector('video'); if (!v) return;
    if (v.paused) { delete v.dataset.userPaused; v.play().catch(() => {}); b.setAttribute('aria-label', 'Pause video'); b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><rect x="7" y="5" width="3.5" height="14"/><rect x="13.5" y="5" width="3.5" height="14"/></svg>'; }
    else { v.dataset.userPaused = '1'; v.pause(); b.setAttribute('aria-label', 'Play video'); b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M8 5l11 7-11 7z"/></svg>'; }
  });
  const MOMENTS = D.moments.map(momentHTML).filter(Boolean);
  let peekIO;
  function feedRound() {
    let html = '';
    const n = Math.ceil(LIST.length / 6);
    for (let i = 0, m = 0; i < LIST.length; i += 6, m++) {
      const chunk = LIST.slice(i, i + 6), cols = [[], []], h = [0, 0];
      chunk.forEach((p) => { const c = h[0] <= h[1] ? 0 : 1; cols[c].push(p); h[c] += tall(p) ? 1.5 : 1.25; });
      html += `<div class="masonry"><div class="col">${cols[0].map(card).join('')}</div><div class="col">${cols[1].map(card).join('')}</div></div>`;
      // One brand space after each block of pieces; whatever is left shows after the last block, each once.
      if (m < n - 1) { if (MOMENTS[m]) html += MOMENTS[m]; }
      else html += MOMENTS.slice(m).join('');
    }
    return html;
  }
  function renderFeed() {
    if (!LIST.length) { $('feed').innerHTML = '<p class="empty">New pieces are on their way.</p>'; return; }
    $('feed').innerHTML = feedRound();
    watchPeeks();
    watchVideos();
  }
  // Brand space videos download only when they are about to scroll into view, and pause when they leave it.
  let vidIO;
  const wake = (v) => { if (v.dataset.lazy) { v.src = v.dataset.lazy; v.removeAttribute('data-lazy'); } };
  function watchVideos() {
    const vids = document.querySelectorAll('#feed video:not([data-vw])');
    if (!('IntersectionObserver' in window)) { vids.forEach((v) => { wake(v); v.play().catch(() => {}); }); return; }
    if (!vidIO) vidIO = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { wake(v); if (!v.dataset.userPaused) v.play().catch(() => {}); }
      else if (!v.dataset.lazy) v.pause();
    }), { rootMargin: '300px 0px' });
    vids.forEach((v) => { v.dataset.vw = '1'; vidIO.observe(v); });
  }
  function watchPeeks() {
    if (!peekIO) peekIO = new IntersectionObserver((es) => es.forEach((e) => {
      const el = e.target;
      if (e.isIntersecting && e.intersectionRatio > .85 && !el.dataset.peeked) {
        el._t = setTimeout(() => { el.dataset.peeked = '1'; el.classList.add('peeking'); setTimeout(() => el.classList.remove('peeking'), 2200); }, 1400);
      } else clearTimeout(el._t);
    }), { threshold: [0, .85] });
    document.querySelectorAll('.card__media:not([data-obs])').forEach((el) => { el.dataset.obs = '1'; if (el.querySelector('.peek')) peekIO.observe(el); });
  }

  // ---------- cart (Shopify AJAX API) ----------
  function setCount(n) {
    cartCount = n;
    [$('badge'), $('vBadge')].forEach((b) => { b.hidden = !n; b.textContent = n; });
    $('cartPill').hidden = !n;
    $('cartPill').innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>Cart · ${n}`;
  }
  async function addToCart(handle) {
    const p = BY[handle];
    if (!p || !sellable(p)) { toast('This piece is not available yet'); return; }
    try {
      const r = await fetch(D.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.variant, quantity: 1 }] }) });
      const j = await r.json();
      if (!r.ok) { toast(j.description || j.message || 'Could not add to cart'); return; }
      setCount(cartCount + 1);
      toast('Added ' + p.title);
      document.querySelectorAll(`[data-add="${CSS.escape(handle)}"]`).forEach((b) => { b.classList.add('done'); if (b.classList.contains('add-sq')) b.innerHTML = ICON.check; });
      document.querySelectorAll(`[data-vadd="${CSS.escape(handle)}"]`).forEach((b) => { b.textContent = 'Added · add another'; });
    } catch (e) { toast('Could not add to cart. Check your connection.'); }
  }
  async function getCart() { const r = await fetch(D.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function openCart() {
    let c;
    try { c = await getCart(); } catch (e) { location.href = D.routes.cart; return; }
    setCount(c.item_count);
    if (!c.item_count) { openSheet('<h2>Your cart is empty</h2><p class="sub">Tap + on any piece to add it.</p>', 'Cart'); return; }
    openSheet(`<h2>Cart</h2>${c.items.map((it) => `<div class="cart-line">${it.image ? `<img alt="" src="${esc(sized(it.image, 160))}">` : ''}<div><p style="font-family:var(--display);font-size:17px">${esc(it.product_title)}</p><p class="sub" style="margin:0">${money(it.final_line_price)}</p>
        <div class="qty"><button type="button" data-qty="${esc(it.key)}" data-to="${it.quantity - 1}" aria-label="Decrease quantity">−</button><span>${it.quantity}</span><button type="button" data-qty="${esc(it.key)}" data-to="${it.quantity + 1}" aria-label="Increase quantity">+</button></div>
        <button class="rm" type="button" data-qty="${esc(it.key)}" data-to="0">Remove</button></div></div>`).join('')}
      <ul class="trust" style="margin-top:18px">${TRUST.slice(0, 3).map(([k, b]) => `<li>${ic(k, 18)}<div><span style="color:var(--ink)">${esc(b)}</span></div></li>`).join('')}</ul>
      <div class="cart-total"><span>Subtotal</span><span>${money(c.total_price)}</span></div>
      <a class="btn btn--dark" href="/checkout" style="display:flex;align-items:center;justify-content:center;text-decoration:none">Checkout</a>
      <p class="note">Shipping and taxes are calculated at checkout.</p>`, 'Cart');
  }
  async function changeQty(key, qty) {
    try {
      await fetch(D.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      openCart();
    } catch (e) { toast('Could not update the cart'); }
  }

  // ---------- saved ----------
  function toggleSave(handle, force) {
    const on = force === undefined ? !saved.has(handle) : force;
    on ? saved.add(handle) : saved.delete(handle);
    store.set('mn-saved', [...saved]);
    document.querySelectorAll(`[data-save="${CSS.escape(handle)}"]`).forEach((b) => b.setAttribute('aria-pressed', on));
    if (on) toast('Saved ' + BY[handle].title);
    renderStories();
  }

  // ---------- viewer ----------
  let viewerOpen = false, io, viewList = null, vRounds = 1, basePath = location.pathname + location.search, pushed = false;
  function slideHTML(p, i, total) {
    const imgs = p.imgs.length ? p.imgs : [''];
    const can = sellable(p);
    return `<section class="slide" data-h="${esc(p.handle)}" data-idx="${i}">
      <div class="gal" data-gal>${imgs.map((src, k) => `<div class="gal__item">${src ? `<img draggable="false" alt="${esc(p.title)}, photo ${k + 1}" src="${esc(src)}" ${k > 1 ? 'loading="lazy"' : ''}>` : ''}</div>`).join('')}</div>
      <svg class="heart-pop" viewBox="0 0 24 24" fill="#E07A55" aria-hidden="true"><path d="M12 21s-8-5-8-11.5A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 8 2.5C20 16 12 21 12 21z"/></svg>
      ${imgs.length > 1 ? `<div class="dots" aria-hidden="true">${imgs.map((_, k) => `<span class="${k ? '' : 'on'}"></span>`).join('')}</div>` : ''}
      <div class="rail">
        <button type="button" data-save="${esc(p.handle)}" aria-pressed="${saved.has(p.handle)}" aria-label="Save ${esc(p.title)}">${ic('heart', 22)}</button>
        <button type="button" data-share="${esc(p.handle)}" aria-label="Share ${esc(p.title)}"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12v7h16v-7M12 3v13M7 8l5-5 5 5"/></svg></button>
      </div>
      <div class="info pad">
        <div class="info__row"><div><p class="info__name">${esc(p.title)}</p><p class="info__meta">${esc(metaText(p))}</p></div><p class="info__price">${priceText(p)}</p></div>
        <div class="info__actions"><button class="btn btn--light" type="button" data-vadd="${esc(p.handle)}" ${can ? '' : 'disabled'}>${can ? 'Add to cart' : (p.price > 0 ? 'Sold out' : 'Coming soon')}</button><button class="btn btn--ghost" type="button" data-details="${esc(p.handle)}">Details</button></div>
        ${TRUST.length ? `<p class="trustline">${TRUST.slice(0, 3).map(([k, b]) => `<span>${ic(k, 14)}${esc(b)}</span>`).join('')}</p>` : ''}
      </div>
    </section>`;
  }
  const VMOMENTS = D.moments.filter((m) => m.inViewer && (m.type === 'statement' || (m.type === 'video' && (m.video || m.img)))).map((m) => m.type === 'statement'
    ? `<section class="slide"><div class="vmoment vmoment--clay pad">${m.eyebrow ? `<p class="eyebrow" style="color:#F6E2CF">${esc(m.eyebrow)}</p>` : ''}<p class="moment__big">${esc(m.heading)}</p>${m.text ? `<p class="moment__text">${esc(m.text)}</p>` : ''}<p class="hint">Keep swiping</p></div></section>`
    : `<section class="slide"><div class="vloop">${m.video ? `<video data-lazy="${esc(m.video)}" muted loop playsinline preload="none"></video>` : `<img alt="" src="${esc(m.img)}">`}</div><div class="info pad"><p class="info__name">${esc(m.heading)}</p>${m.text ? `<p class="info__meta">${esc(m.text)}</p>` : ''}</div></section>`);
  function viewerRound(list, r) {
    let html = r ? `<section class="slide"><div class="vmoment pad" style="background:var(--night-2)"><p class="eyebrow" style="color:var(--on-night-muted)">That's every piece</p><p class="moment__big">Back to the start.</p><p class="moment__text" style="color:var(--on-night-muted)">Keep swiping, or tap Feed to go back.</p></div></section>` : '';
    list.forEach((p, i) => {
      html += slideHTML(p, i, list.length);
      if (VMOMENTS.length && (i + 1) % 4 === 0 && i < list.length - 1) html += VMOMENTS[(Math.floor(i / 4) + r) % VMOMENTS.length];
    });
    return html;
  }
  function wireViewer() {
    $('scroller').querySelectorAll('[data-gal]:not([data-w])').forEach((g) => { g.dataset.w = '1'; wireGallery(g); });
    $('scroller').querySelectorAll('.slide:not([data-o])').forEach((s) => { s.dataset.o = '1'; io.observe(s); });
  }
  function buildViewer() {
    const list = viewList || LIST;
    vRounds = 1;
    $('scroller').innerHTML = viewerRound(list, 0);
    if (io) io.disconnect();
    io = new IntersectionObserver((ents) => ents.forEach((en) => {
      const v = en.target.querySelector('video');
      if (v) { if (en.isIntersecting) { if (v.dataset.lazy) { v.src = v.dataset.lazy; v.removeAttribute('data-lazy'); } v.play().catch(() => {}); } else v.pause(); }
      if (en.isIntersecting && en.intersectionRatio > .6) {
        const h = en.target.dataset.h;
        $('vCount').textContent = h ? (+en.target.dataset.idx + 1) + ' / ' + list.length : '';
        if (h && pushed) { try { history.replaceState({ mn: 1 }, '', BY[h].url); } catch (e) {} }
        const all = $('scroller').children;
        if ([...all].indexOf(en.target) >= all.length - 3 && vRounds < 20 && list.length > 1) { $('scroller').insertAdjacentHTML('beforeend', viewerRound(list, vRounds++)); wireViewer(); }
      }
    }), { root: $('scroller'), threshold: [0, .6] });
    wireViewer();
  }
  function wireGallery(g) {
    const dots = g.parentElement.querySelectorAll('.dots span');
    g.addEventListener('scroll', () => { const k = Math.round(g.scrollLeft / g.clientWidth); dots.forEach((d, j) => d.classList.toggle('on', j === k)); }, { passive: true });
    let last = 0;
    g.addEventListener('pointerup', () => {
      const now = Date.now();
      if (now - last < 300) {
        toggleSave(g.parentElement.dataset.h, true);
        const hp = g.parentElement.querySelector('.heart-pop'); hp.classList.remove('go'); void hp.offsetWidth; hp.classList.add('go');
        last = 0;
      } else last = now;
    });
  }
  function openViewer(handle, list, push = true) {
    viewList = list || null;
    buildViewer();
    $('viewer').hidden = false; viewerOpen = true;
    document.body.style.overflow = 'hidden';
    const target = $('scroller').querySelector(`.slide[data-h="${CSS.escape(handle)}"]`);
    $('scroller').scrollTop = target ? target.offsetTop : 0;
    if (push) { try { history.pushState({ mn: 1 }, '', BY[handle].url); pushed = true; } catch (e) {} }
    $('coach').hidden = !!store.get('mn-coach', false);
    $('vClose').focus({ preventScroll: true });
  }
  function closeViewer(fromPop) {
    if (!viewerOpen) return;
    viewerOpen = false; $('viewer').hidden = true; document.body.style.overflow = '';
    $('scroller').querySelectorAll('video').forEach((v) => v.pause());
    if (!fromPop && pushed) { pushed = false; history.back(); return; }
    if (!pushed) { try { history.replaceState(null, '', basePath); } catch (e) {} }
    pushed = false; viewList = null;
  }
  window.addEventListener('popstate', () => { if (viewerOpen) { pushed = false; closeViewer(true); } });
  $('vClose').addEventListener('click', () => closeViewer(false));
  $('coachOk').addEventListener('click', () => { $('coach').hidden = true; store.set('mn-coach', true); });
  let y0 = null, x0 = null, ey0 = 0;
  $('scroller').addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    y0 = $('scroller').scrollTop <= 0 ? t.clientY : null;
    x0 = t.clientX - $('scroller').getBoundingClientRect().left < 28 ? t.clientX : null; ey0 = t.clientY;
  }, { passive: true });
  $('scroller').addEventListener('touchmove', (e) => {
    const t = e.touches[0];
    if (y0 !== null && t.clientY - y0 > 110) { y0 = null; closeViewer(false); return; }
    if (x0 !== null && t.clientX - x0 > 70 && Math.abs(t.clientY - ey0) < 50) { x0 = null; closeViewer(false); }
  }, { passive: true });

  // ---------- sheets ----------
  function openSheet(html, label) { $('sheet').innerHTML = '<div class="grab"></div>' + html; $('sheet').setAttribute('aria-label', label); $('sheetBack').hidden = false; }
  function closeSheet() { $('sheetBack').hidden = true; }
  $('sheetBack').addEventListener('click', (e) => { if (e.target === $('sheetBack')) closeSheet(); });
  function openDetails(handle) {
    const p = BY[handle];
    openSheet(`<h2>${esc(p.title)}</h2><p class="sub">${esc(metaText(p))}${metaText(p) ? ' · ' : ''}${priceText(p)}</p>
      <div class="acc">
        ${p.desc ? `<details open><summary>About this piece</summary><p>${esc(p.desc)}</p></details>` : ''}
        <details${p.desc ? '' : ' open'}><summary>Every piece varies</summary><p>The piece you receive will not be identical to the one photographed. Firing marks come from the kiln and are not damage. Cracks, chips or a missing drainage hole are defects, and we take those back.</p></details>
        <details><summary>Care</summary><p>Clay darkens gradually where it holds water. Wipe with a dry or damp cloth.</p></details>
        ${TRUST.length ? `<details><summary>Delivery and payment</summary><p>${TRUST.slice(0, 3).map((t) => esc(t[1])).join('. ')}.</p></details>` : ''}
      </div>
      ${sellable(p) ? `<button class="btn btn--dark" type="button" data-add="${esc(p.handle)}" style="margin-top:20px">Add to cart</button>` : ''}`, p.title + ' details');
  }

  // ---------- menu ----------
  function contactHTML() {
    return `<div class="page"><h2>Contact</h2><p>The fastest way to reach us is WhatsApp.</p>
      ${T.whatsapp ? `<h3>WhatsApp</h3><p class="copyable">${esc(T.whatsapp)}</p><p><a href="https://wa.me/${esc(T.whatsapp.replace(/[^0-9]/g, ''))}" target="_blank" rel="noopener">Open WhatsApp</a></p>` : ''}
      ${T.email ? `<h3>Email</h3><p class="copyable">${esc(T.email)}</p>` : ''}
      ${T.hours ? `<h3>Hours</h3><p>${esc(T.hours)}</p>` : ''}</div>`;
  }
  function openDrawer() {
    const help = D.menu.map((l, i) => `<li><button class="drawer__link" type="button" data-page="menu-${i}">${esc(l.title)}</button></li>`).join('');
    const pols = [document.getElementById('mn-pol-shipping') && ['pol-shipping', 'Shipping'], document.getElementById('mn-pol-refund') && ['pol-refund', 'Returns and refunds']].filter(Boolean)
      .map(([k, t]) => `<li><button class="drawer__link" type="button" data-page="${k}">${t}</button></li>`).join('');
    const word = document.querySelector('.lockup__main');
    $('drawer').innerHTML = `<nav class="drawer pad" aria-label="Site">
      <div class="drawer__head"><span class="lockup__main" style="font-size:20px">${esc(word ? word.textContent : 'Menu')}</span><button class="icon-btn" type="button" data-page="close" aria-label="Close menu"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
      <p class="drawer__label">Shop</p><ul class="drawer__group">
        <li><button class="drawer__link" type="button" data-page="shop">All pieces <small>${LIST.length}</small></button></li>
        <li><button class="drawer__link" type="button" data-page="saved">Saved <small>${saved.size}</small></button></li>
        <li><button class="drawer__link" type="button" data-page="cart">Cart <small>${cartCount}</small></button></li></ul>
      ${help || pols ? `<p class="drawer__label">Help</p><ul class="drawer__group">${help}${pols}</ul>` : ''}
      <p class="drawer__label">Talk to us</p><ul class="drawer__group"><li><button class="drawer__link" type="button" data-page="contact">Contact</button></li></ul>
      ${T.whatsapp ? `<p class="drawer__foot">WhatsApp ${esc(T.whatsapp)}</p>` : ''}
    </nav>`;
    $('drawer').hidden = false;
  }
  function closeDrawer() { $('drawer').hidden = true; }
  function openPage(key) {
    closeDrawer();
    if (key === 'shop') { if (viewerOpen) closeViewer(false); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if (key === 'saved') { openStory('saved'); return; }
    if (key === 'cart') { openCart(); return; }
    if (key === 'contact') { openSheet(contactHTML(), 'Contact'); return; }
    if (key.startsWith('pol-')) { openSheet($('mn-' + key).innerHTML, 'Policy'); return; }
    if (key.startsWith('menu-')) {
      const l = D.menu[+key.slice(5)];
      if (l.tpl && document.getElementById(l.tpl)) openSheet(document.getElementById(l.tpl).innerHTML, l.title);
      else location.href = l.url;
    }
  }
  $('menuBtn').addEventListener('click', openDrawer);
  $('drawer').addEventListener('click', (e) => {
    if (e.target === $('drawer')) { closeDrawer(); return; }
    const b = e.target.closest('[data-page]'); if (!b) return;
    e.stopPropagation();
    b.dataset.page === 'close' ? closeDrawer() : openPage(b.dataset.page);
  });

  // ---------- stories ----------
  const STORIES = [];
  D.stories.forEach((s) => {
    if (!s.img && !s.video) return;
    let st = STORIES.find((x) => x.name === s.story);
    if (!st) { if (STORIES.length >= 3) return; st = { name: s.story || 'Story', slides: [] }; STORIES.push(st); }
    st.slides.push(s);
  });
  STORIES.forEach((s) => { s.cover = (s.slides.find((x) => x.img) || {}).img; });
  function renderStories() {
    const savedBtn = `<button class="story seen" type="button" data-story="-1" aria-label="Saved, ${saved.size} pieces"><span class="story__ring story__ring--saved">${ic('heart', 26, saved.size ? 'currentColor' : 'none')}</span>Saved${saved.size ? ' · ' + saved.size : ''}</button>`;
    $('stories').innerHTML = savedBtn + STORIES.map((s, i) => `<button class="story${seen.has(s.name) ? ' seen' : ''}" type="button" data-story="${i}"><span class="story__ring">${s.cover ? `<img alt="" src="${esc(s.cover)}">` : ''}</span>${esc(s.name)}</button>`).join('');
  }
  let sv = null, wasHeld = false;
  function openStory(key) {
    if (key === 'saved' || key === '-1') {
      const list = LIST.filter((p) => saved.has(p.handle));
      if (!list.length) { toast('Double tap a photo in full screen to save it'); return; }
      openViewer(list[0].handle, list); return;
    }
    sv = { si: +key, i: 0, elapsed: 0, t0: 0, paused: false, raf: 0, dur: 5500 };
    $('sv').hidden = false; document.body.style.overflow = 'hidden';
    showSlide();
  }
  function showSlide() {
    const st = STORIES[sv.si], sl = st.slides[sv.i], vid = $('svVideo'), img = $('svImg');
    $('svBars').innerHTML = st.slides.map((_, k) => `<span><i style="width:${k < sv.i ? 100 : 0}%"></i></span>`).join('');
    $('svName').textContent = st.name;
    vid.pause();
    if (sl.video) {
      vid.hidden = false; img.hidden = !sl.img; if (sl.img) img.src = sl.img;
      vid.src = sl.video; vid.currentTime = 0; vid.play().catch(() => {});
      vid.onloadedmetadata = () => { if (sv && isFinite(vid.duration)) sv.dur = Math.min(30000, vid.duration * 1000); };
      sv.dur = 8000;
    } else { vid.hidden = true; vid.removeAttribute('src'); img.hidden = false; img.src = sl.img; sv.dur = 5500; }
    $('svCap').innerHTML = `${sl.title ? `<p class="sv__title">${esc(sl.title)}</p>` : ''}${sl.text ? `<p class="sv__sub">${esc(sl.text)}</p>` : ''}${sl.shop && BY[sl.shop] ? `<button class="btn btn--light" type="button" data-svshop="${esc(sl.shop)}" style="width:100%">Shop this piece</button>` : ''}`;
    sv.elapsed = 0; sv.t0 = performance.now();
    cancelAnimationFrame(sv.raf); tick();
  }
  function tick() {
    if (!sv) return;
    const now = performance.now();
    if (!sv.paused) sv.elapsed += now - sv.t0;
    sv.t0 = now;
    const bar = $('svBars').children[sv.i];
    if (bar) bar.firstChild.style.width = Math.min(100, sv.elapsed / sv.dur * 100) + '%';
    if (sv.elapsed >= sv.dur) { storyNext(); return; }
    sv.raf = requestAnimationFrame(tick);
  }
  function storyNext() {
    const st = STORIES[sv.si];
    if (sv.i < st.slides.length - 1) { sv.i++; showSlide(); return; }
    seen.add(st.name);
    if (sv.si < STORIES.length - 1) { sv.si++; sv.i = 0; showSlide(); } else closeStory();
  }
  function storyPrev() {
    if (sv.i > 0) { sv.i--; showSlide(); return; }
    if (sv.si > 0) { sv.si--; sv.i = 0; } showSlide();
  }
  function closeStory() {
    if (!sv) return;
    seen.add(STORIES[sv.si].name); store.set('mn-seen', [...seen]);
    cancelAnimationFrame(sv.raf); sv = null;
    $('svVideo').pause();
    $('sv').hidden = true; document.body.style.overflow = '';
    renderStories();
  }
  $('svNext').addEventListener('click', () => { if (sv && !wasHeld) storyNext(); wasHeld = false; });
  $('svPrev').addEventListener('click', () => { if (sv && !wasHeld) storyPrev(); wasHeld = false; });
  $('svClose').addEventListener('click', closeStory);
  $('svCap').addEventListener('click', (e) => { const b = e.target.closest('[data-svshop]'); if (b) { e.stopPropagation(); const h = b.dataset.svshop; closeStory(); openViewer(h); } });
  let holdT, sy = null;
  $('svFrame').addEventListener('pointerdown', (e) => { if (!sv) return; sy = e.clientY; holdT = setTimeout(() => { if (sv) { sv.paused = true; $('svVideo').pause(); } }, 180); });
  $('svFrame').addEventListener('pointerup', (e) => {
    clearTimeout(holdT);
    if (!sv) return;
    if (sy !== null && e.clientY - sy > 90) { closeStory(); return; }
    wasHeld = sv.paused;
    if (sv.paused) { sv.paused = false; if (!$('svVideo').hidden) $('svVideo').play().catch(() => {}); }
    sy = null;
  });

  // ---------- global clicks + keys ----------
  document.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.story !== undefined) openStory(t.dataset.story);
    else if (t.dataset.open) openViewer(t.dataset.open);
    else if (t.dataset.add) addToCart(t.dataset.add);
    else if (t.dataset.vadd) addToCart(t.dataset.vadd);
    else if (t.dataset.save) toggleSave(t.dataset.save);
    else if (t.dataset.details) openDetails(t.dataset.details);
    else if (t.dataset.qty) changeQty(t.dataset.qty, +t.dataset.to);
    else if (t.dataset.share) {
      const p = BY[t.dataset.share], url = location.origin + p.url;
      if (navigator.share) navigator.share({ title: p.title, url }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => toast('Link copied'), () => toast(url));
      else toast(url);
    }
  });
  [$('cartBtn'), $('cartPill'), $('vCart')].forEach((b) => b.addEventListener('click', openCart));
  document.addEventListener('keydown', (e) => {
    if (!$('sheetBack').hidden) { if (e.key === 'Escape') closeSheet(); return; }
    if (!$('drawer').hidden) { if (e.key === 'Escape') closeDrawer(); return; }
    if (sv) { if (e.key === 'Escape') closeStory(); if (e.key === 'ArrowRight') storyNext(); if (e.key === 'ArrowLeft') storyPrev(); return; }
    if (!viewerOpen) return;
    const sc = $('scroller'), h = sc.clientHeight;
    if (e.key === 'Escape') closeViewer(false);
    if (e.key === 'ArrowDown') { e.preventDefault(); sc.scrollBy({ top: h, behavior: 'smooth' }); }
    if (e.key === 'ArrowUp') { e.preventDefault(); sc.scrollBy({ top: -h, behavior: 'smooth' }); }
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      const cur = [...sc.querySelectorAll('.slide')].find((s) => Math.abs(s.offsetTop - sc.scrollTop) < h / 2);
      const g = cur && cur.querySelector('[data-gal]');
      if (g) g.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * g.clientWidth, behavior: 'smooth' });
    }
  });

  // ---------- boot ----------
  renderStories(); renderFeed(); setCount(cartCount);
  if (D.start && BY[D.start]) openViewer(D.start, LIST.some((p) => p.handle === D.start) ? null : [BY[D.start]].concat(LIST), false);
})();
